import React from 'react';
import {
  useNextUpReviewContext,
} from 'Views/Page/Content/Modal/Layouts/FacetPlanProposalNextUpReview/Layout/Components/NextUpContext';
import DialogTitle from './DialogTitle';
import DialogContent from './DialogContent';
import DialogActions from './DialogActions';

const NextUpActionsDialog = () => {
  const { nextUpReviewResource } = useNextUpReviewContext();

  if (!nextUpReviewResource) {
    return null;
  }

  return (
    <>
      <DialogTitle />
      <DialogContent />
      <DialogActions />
    </>
  );
};

export default NextUpActionsDialog;
